import { useRef } from 'react';

import { useLegalClientSaveW8BENForm } from 'api/requests';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { W8BenFormFormType } from 'modules/onboarding/common/forms/w8BenFormForm';
import {
  getInitialData,
  getSubmitData,
} from 'modules/onboarding/common/helpers/w8BenForm';

import { useOnboardingContext } from './useOnboardingContext';

export const useW8BenForm = () => {
  const { t } = useTranslation();

  const { goToBack, goToNext, data } = useOnboardingContext();
  const {
    saveW8BenForm,
    error,
    loading: submitLoading,
  } = useLegalClientSaveW8BENForm();

  const initialData = useRef(
    getInitialData(t, data.legalClient!.W8BENForm)
  ).current;
  const initialValues = useRef(initialData.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData.files);

  const onSubmit = async (values: W8BenFormFormType) => {
    const submitData = getSubmitData(values);
    await saveW8BenForm(data.legalClient!.id, submitData);
    goToNext();
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
    files,
    submitLoading,
    submitDisabled,
    initialValues,
  };
};
